import { Component, OnInit, HostListener } from '@angular/core';
import { PaymentsService } from '../../services/payments/payments.service';
import { environment } from '../../../environments/environment';
import { OAuthService } from '../../services/o-auth/o-auth.service';
import { ApiService } from './../../services/api';

@Component({
    selector: 'app-payments-list',
    templateUrl: './payments-list.component.html',
})
export class PaymentsListComponent implements OnInit {
    paymentHandler: any;
    public amount = 50000;
    public payments: Array<any>;
    public daysLeft: number;
    public club: any;
    public subscriptionList: Array<any> = [];
    public month: number;
    constructor(private apiService: ApiService, private paymentsService: PaymentsService, private oAuthService: OAuthService) { }

    ngOnInit() {
        this.subscriptionList.push({ name: '3 months subscription', price: 5, month: 3 },
            { name: '6 months subscription', price: 8, month: 6 },
            { name: '12 months subscription', price: 15, month: 12 });
        const club = this.oAuthService.getClub();
        this.apiService.object(`/users/${club.$key}`)
            .then(club1 => {
                this.club = club1;
                const now = new Date();
                console.log(club1['subscription'])
                if (club1['subscription']) {
                    if ((club1['subscription'] * 1000) > now.getTime()) {
                        this.daysLeft = Math.round(Math.abs(((club1['subscription'] * 1000) - now.getTime()) / (24 * 60 * 60 * 1000)))

                    } else {
                        this.daysLeft = -1;
                    }
                } else {
                    if (club['trial']) {
                        if ((club['trial'] * 1000) > now.getTime()) {
                            this.daysLeft = Math.round(Math.abs(((club['trial'] * 1000) - now.getTime()) / (24 * 60 * 60 * 1000)))

                        } else {
                            this.daysLeft = -3;
                        }
                    } else {
                        this.daysLeft = -2;
                    }
                }


            })
        //   console.log(club)
        this.paymentHandler = StripeCheckout.configure({
            key: environment.stripeKey,
            locale: 'auto',
            currency: 'GBP',
            email: club.email,
            token: token => {
                this.paymentsService.processPayment(token, 50000, this.month);
            }
        });
        this.apiService.list(`/club-subscriptions/${club.cid}`)
            .then((pay: Array<any>) => {
                console.log(pay)
                this.payments = pay;
            })

        // this.paymentsService.listPayments()
        //     .subscribe(payments => this.payments = payments);
    }
    openBuySubscription() {
        const club = this.oAuthService.getClub();

        console.log(this.amount)
        var i = -1
        for (i = 0; i < this.subscriptionList.length; i++) {
            if (this.amount == (this.subscriptionList[i].price * 100)) {
                break;
            }
        }
        this.month = 12

        $('#myModal').modal('hide');

        this.paymentHandler.open({
            name: 'Buy subscription',
            description: '',
            amount: 50000
        });

    }

    @HostListener('window:popstate') onPopstate() {
        this.paymentHandler.close();

    }

}
